<div class="dropdown-container">
  <h3>Select an Image</h3>
  <!-- <select class="form-control" [(ngModel)]="selectedImage" (change)="onImageSelect($event)">
  <option value="">-- Select Image --</option>
  <option *ngFor="let image of images" [value]="image.url">{{ image.name }}</option>
</select> -->

@if (selectedImage) {
  <div class="selected-image-preview">
    <h4>Selected Image:</h4>
    <div class="preview-image-wrapper">
      <img [src]="selectedImage" alt="Selected image" style="max-width: 200px; max-height: 200px;">
      <div class="image-preview-info">
        <span class="preview-image-name">{{ getSelectedImageName() }}</span>
        <!-- <button class="preview-expand-btn" (click)="expandSelectedImage()" title="View full size">
        <mat-icon>fullscreen</mat-icon>
      </button> -->
    </div>
  </div>
</div>
}
</div>

<!-- Full Image Modal -->
@if (expandedImage) {
  <div class="image-modal" (click)="closeExpandedImage()">
    <button class="close-btn" (click)="closeExpandedImage()">
      ×
    </button>
    <img [src]="expandedImage" alt="Expanded image" class="expanded-image" (click)="$event.stopPropagation()">
  </div>
}